import React, { SVGProps } from 'react';

const Clone: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="21" height="21" viewBox="0 0 21 21" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5C21 16.299 16.299 21 10.5 21ZM10.9999 10H14.4999C14.7761 10 14.9999 10.2239 14.9999 10.5C14.9999 10.7761 14.7761 11 14.4999 11H10.9999V14.5C10.9999 14.7761 10.7761 15 10.4999 15C10.2238 15 9.99995 14.7761 9.99995 14.5V11H6.49995C6.2238 11 5.99995 10.7761 5.99995 10.5C5.99995 10.2239 6.2238 10 6.49995 10H9.99995V6.5C9.99995 6.22386 10.2238 6 10.4999 6C10.7761 6 10.9999 6.22386 10.9999 6.5V10ZM20 10.5C20 15.7467 15.7467 20 10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1C15.7467 1 20 5.25329 20 10.5Z" fill="#007BC3" />
  </svg>
);

export default Clone;
